import {ServiceRequest} from "../utils/service-request"
import {DATALAKE_CONTRAPARTE_PATH} from "../utils/api-routes"

export class MarketToMarketService {

    constructor() {
        this.request = new ServiceRequest()
    }

    async loadSetorEmpresa(cnpj) {
        const query = `cnpj=${cnpj}`
        return this.request.get(`${DATALAKE_CONTRAPARTE_PATH}/setor?${query}`)
    }

    async loadCurvasEmpresa(cnpj, data, curva, janela, tipoEmissao, subsetor, grupoEconomico) {
        const query = `cnpj=${cnpj}&data_referencia=${data}&curva=${curva}&janela=${janela}&tipo_emissao=${tipoEmissao}&subsetor=${subsetor}&grupo_economico=${grupoEconomico}`
        return this.request.get(`${DATALAKE_CONTRAPARTE_PATH}/curvas-empresa?${query}`)
    }
}